/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Required_BadgeInputs */

const en_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

const fr_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requis`)
};

const de_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderlich`)
};

const it_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necessario`)
};

const ru_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необходимый`)
};

const es_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerido`)
};

const zh_cn2_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必需的`)
};

const ja_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必須`)
};

const hi_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवश्यक`)
};

const pt_pt2_new_project_required_badge = /** @type {(inputs: New_Project_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigatório`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {New_Project_Required_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_required_badge = /** @type {((inputs?: New_Project_Required_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Required_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_required_badge(inputs)
	if (locale === "de") return de_new_project_required_badge(inputs)
	if (locale === "it") return it_new_project_required_badge(inputs)
	if (locale === "ru") return ru_new_project_required_badge(inputs)
	if (locale === "es") return es_new_project_required_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_required_badge(inputs)
	if (locale === "ja") return ja_new_project_required_badge(inputs)
	if (locale === "hi") return hi_new_project_required_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_required_badge(inputs)
	return en_new_project_required_badge(inputs)
});